import React, { useContext, useMemo } from 'react';

import Tooltip from 'app/components/Tooltip';
import EditPencilIcon from 'app/components/shared/icons/edit-pencil';
import useUserData from 'hooks/useUserData';
import { ThemeProvider } from 'styled-components';

import { ResourceDetailContext } from '../ResourceDetailContext';
import { ResourceDetailEditButton, ResourceDetailEditButtonLabel } from './styled';

export default function ResourceDetailEdit() {
  const userData = useUserData();
  const { data: resource, setIsEditing } = useContext(ResourceDetailContext);

  const canEdit = useMemo(() => {
    return resource?.submitter?.uuid === userData?.uuid;
  }, [userData, resource]);

  const canSeeButNotEdit = useMemo(() => {
    return (
      resource.contributors.people.length > 0 &&
      resource.contributors.people.some((person) => person.slug === userData?.slug) &&
      resource.submitter?.uuid !== userData?.uuid
    );
  }, [userData, resource, resource.contributors.people]);

  const handleClick = () => {
    if (canEdit) {
      setIsEditing(true);
    }
  };

  return canEdit || canSeeButNotEdit ? (
    <ThemeProvider theme={{ canSeeButNotEdit }}>
      <Tooltip
        hide={!canSeeButNotEdit}
        text={`Only the creator of this resource: ${resource.submitter?.name} from ${resource.submitter?.company.name} can edit this submission`}
      >
        <ResourceDetailEditButton onClick={handleClick}>
          {canEdit || canSeeButNotEdit ? <EditPencilIcon /> : null}
          <ResourceDetailEditButtonLabel>
            {canEdit || canSeeButNotEdit ? 'EDIT' : ''}
          </ResourceDetailEditButtonLabel>
        </ResourceDetailEditButton>
      </Tooltip>
    </ThemeProvider>
  ) : null;
}
